import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import IconLicenseBadge from "./icon-license-badge";

import { licenses, licensesDisplay, constToCSS } from "../../reducers/download";

const LicenseStrip = props => {
    let { license } = props;
    if (!license) {
        return null;
    }
    let licenseStripClasses = classnames(
        "license-strip",
        "license-icon",
        "license-icon-before",
        "license-icon-small",
        `license-${constToCSS(license)}`
    );
    let licenseText =
        licensesDisplay[license].description || licensesDisplay[license].title;
    return (
        <div className={licenseStripClasses}>
            <IconLicenseBadge>{licenseText}</IconLicenseBadge>
        </div>
    );
};

export default LicenseStrip;
